import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { DashboardComponent } from './shared/components/layout/dashboard/dashboard.component';


const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'chat',
    loadChildren: () => import('./features/chat/chat.module').then(m => m.ChatModule),

  },


  // --- ADD THIS NEW ROUTE ---
  {
  path: 'dashboard',
  component: DashboardComponent,
  canActivate: [AuthGuard]
}
,
  {
    path: 'templates',
    loadChildren: () => import('./features/templates/templates.module').then(m => m.TemplatesModule),
    canActivate: [AuthGuard]
  },
  // { path: '', redirectTo: '/chat', pathMatch: 'full' },

 



  // Rule 3: If the user visits the base URL (''), redirect them to '/chat'.
  // The AuthGuard on the '/chat' route will handle the rest. If they are not
  // logged in, the guard will automatically send them to the login page.
  // {
  //   path: '',
  //   redirectTo: '/auth',
  //   pathMatch: 'full'
  // },

  // (Optional but good practice) A wildcard route to redirect any unknown URLs.
  {
    path: '**',
    redirectTo: '/auth'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
